<template>
  <div class="textC">
    <div v-if="$route.query.step == 1">
      <img src="https://homeimage.ksaxshop.com/form.png" alt="" width="100px">
      <h3 class="mgt20">提交申请成功，请等待处理</h3>
      <p class="mgt20">预计审核时间1-3天</p>
    </div>
    <div v-if="$route.query.step == 2" class="flex flex-center flex-jc" style="color: #3b6ffa;">
      <i class="el-icon-success" style="font-size: 40px;"></i>
      <h3 class="mgl10">入驻成功</h3>
    </div>
    <div v-if="$route.query.step == 3" class="flex flex-center flex-jc" style="color:#f5996c;">
      <i class="el-icon-error" style="font-size: 40px;"></i>
      <h3 class="mgl10">入驻失败</h3>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped></style>
